"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } // src/router/modules/userTask.js
/** When your routing table is too long, you can split it into small modules **/
var userTaskRouter = {
  path: '/userTask',
  component: _layout.default,
  redirect: '/userTask/userTask',
  name: 'userTask',
  alwaysShow: true,
  // 总是显示根菜单
  meta: {
    title: '任务中心',
    icon: 'tasks'
  },
  children: [{
    path: 'userTask',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user-task/TaskConfigList'));
      });
    },
    // 实际组件为 Tab 主页
    name: 'UserTaskConfig',
    meta: {
      title: '任务管理',
      icon: ''
    }
  }]
};
var _default = exports.default = userTaskRouter;